<template>
	<div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Edit Comment</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <form class="p-6 pt-2 flex-1 text-lg">
                <div class="flex flex-col">
                    <div class="flex flex-col">
                        <div class="py-3 w-full flex flex-col">
                            <label for="comment">Comment</label>
                            <textarea
                                name="comment"
                                v-model="comment.comment"
                                class="mt-1 p-4 form-textarea"
                                :class="{ 'border-red-500': errors.comment }"
                                rows="10"
                                placeholder="Enter your comment here">
                            </textarea>
                            <div v-if="errors.comment" class="form-error">{{ errors.comment[0] }}</div>
                        </div>

                        <div class="mt-6 w-full flex flex-col">
                            <div v-if="comment.attachment_id && comment.attachment" class="p-4 border-t-4 border-indigo-600 shadow">
                                <div class="flex items-center">
                                    <div v-if="comment.attachment.is_image">
                                        <a :href="`#${comment.attachment.name}`">
                                            <img :src="comment.attachment.view_url" class="w-10 h-10 object-cover rounded-full shadow-md">
                                        </a>
                                        <a href="#_" class="lightbox" :id="`${comment.attachment.name}`">
                                            <img :src="comment.attachment.view_url">
                                        </a>
                                    </div>
                                    <div v-else v-html="comment.attachment.icon" class="w-10 h-10"></div>

                                    <div class="flex flex-1 items-center justify-between">
                                        <div class="ml-3 flex flex-1 flex-col">
                                            <div v-if="comment.attachment.is_image">
                                                <a :href="`#${comment.attachment.name}`" class="text-blue-700 font-semibold hover:no-underline truncate">
                                                    {{ comment.attachment.name | truncate(45) }}
                                                </a>
                                            </div>
                                            <p v-else class="text-blue-700 font-semibold truncate">{{ comment.attachment.name | truncate(45) }}</p>
                                            <p v-if="comment.attachment.description" class="text-smest mt-1">{{ comment.attachment.description }}</p>
                                        </div>
                                        <div class="flex space-x-2">
                                            <a class="btn btn-action" :href="comment.attachment.view_url" target="_blank" title="Open Attachment">
                                                View
                                            </a>
                                            <a class="btn btn-action" :href="comment.attachment.download_url" title="Download Attachment">
                                                Download
                                            </a>
                                            <button @click="comment.attachment_id = null" type="button" class="btn btn-action" title="Remove Attachment">
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <attachment-manager
                                    :commentable-data="comment.commentable"
                                    @document-attached="comment.attachment_id = $event"
                                    ref="attachmentUploader"
                                ></attachment-manager>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="bg-gray-100 p-4">
                <div class="text-right">
					<button class="btn btn-secondary mr-2" @click.prevent="hideModal">Close</button>
					<button class="btn btn-green" @click.prevent="save">Save Comment</button>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

    export default {
        props: ['commentId'],

        data() {
            return {
            	comment: '',
            	errors: {}
            }
        },

        created() {
        	this.comment = _.clone(_.find(this.comments.all, (comment) => comment.id == this.commentId));
        },

        computed: {
        	...mapState(['comments']),
        },

        methods: {
            async save() {
                await this.$eventHub.$emit('upload-comment-attachment');

				axios.patch('/comments/' + this.comment.id, this.comment).then(response => {
					this.comment = response.data.comment;
                	this.$emit('comment-updated', response.data.comment);

					this.$notify({
						type: 'success',
						title: 'Success',
						text: response.data.message
					});

					this.hideModal();
                }).catch(error => {
					this.$notify({
						type: 'error',
						title: 'Error',
						text: error.response.data.message
					});
                });
            },
        }
    }
</script>